import { createFileRoute } from '@tanstack/react-router'

function UserDashboard() {
  return (
    <div className="p-6">
      <h1 className="text-xl font-semibold text-gray-900">Dashboard</h1>
      <p className="mt-2 text-sm text-gray-500">
        The customer experience lives in the cleaning-app. This admin app focuses on operations.
      </p>
    </div>
  )
}

export const Route = createFileRoute('/(user)/dashboard/')({ component: UserDashboard })
